/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.CostTypeResponseDto>>;
export function request(
  params: API.tms.costType.postPage.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/costType/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
